import { LoginButton } from '@Components/LoginButton';
import { Button, FlexColumn, useTranslate } from '@synqo/frontend-component-library';

export interface ClientInfo {
    id: string;
    display: string;
    locked: boolean;
}

interface IClientSelectionProps {
    clients: ClientInfo[];
    selectClient: (id: string) => void;
}

export function ClientSelection({ clients, selectClient }: IClientSelectionProps) {
    const i18n = useTranslate('');

    if (clients.length === 0) {
        return (
            <FlexColumn>
                <p>{i18n('Sie haben auf dieses System keinen Zugriff!')}</p>
                <LoginButton />
            </FlexColumn>
        );
    }

    return (
        <FlexColumn>
            <small>{i18n('Bitte wählen Sie einen Kunden')}</small>
            {clients.map((client) => (
                <Button
                    key={client.id}
                    appearance="outlined"
                    onClick={() => selectClient(client.id)}
                    locked={client.locked}
                    tooltip={client.locked ? 'Dieser Kunde ist aktuell nicht verfügbar.' : null}
                >
                    {client.display}
                </Button>
            ))}
            <LoginButton />
        </FlexColumn>
    );
}
